import { startsWith } from 'lodash';
import React from 'react';

export default (e: unknown): e is React.MouseEvent<any> =>
  e && (e as any).type && startsWith((e as any).type, 'mouse');
